<template>
  <div
    class="relative mx-auto aspect-[9/18] w-36 rounded-[2rem] border-[6px] border-neutral-900 bg-linear-to-b from-brand-blue-300 via-brand-blue-500 to-brand-blue-800 p-3 shadow-2xl"
    aria-hidden="true"
  >
    <div class="absolute left-1/2 top-1.5 h-1.5 w-10 -translate-x-1/2 rounded-full bg-neutral-900" />
    <div class="mt-5 grid grid-cols-3 gap-x-2 gap-y-3">
      <div
        v-for="i in 8"
        :key="i"
        class="aspect-square rounded-lg bg-white/25"
      />
      <div class="relative flex flex-col items-center">
        <span class="absolute -inset-1 animate-ping rounded-xl bg-white/60" />
        <img
          src="/icons/volontaires-192.png"
          alt=""
          class="relative aspect-square w-full rounded-lg shadow-lg ring-2 ring-white"
        >
        <span class="relative mt-0.5 text-[8px] font-semibold text-white">AP 2.0</span>
      </div>
    </div>
  </div>
</template>
